<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M14.978 2.984h-.7V2H9.551v.984h-.7C7.825 2.984 7 3.817 7 4.834V20.15C7 21.175 7.834 22 8.85 22h6.128c1.026 0 1.851-.834 1.851-1.85V4.842c0-1.026-.834-1.85-1.85-1.85v-.01Zm-.733 8.979-3.76 5.885c-.075.117-.25.042-.217-.091l1-4.352H9.86a.237.237 0 0 1-.234-.292l1.059-4.635a.481.481 0 0 1 .467-.375h2.834c.192 0 .309.208.2.366l-1.992 3.118h1.842c.192 0 .3.209.2.367l.009.008Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
